export default function () {
  return {
    isSavingSeatedPatientTransport: false,
  };
}
